var template = require('./profile_banking_info_v2.html.slim')
declare var angular
declare var window

export class ProfileBankingInfoV2Controller {
  static $inject = ['ProfileBankingInfo', '$routeParams', '$scope', '$resource', 'brand']

  bankingInfo;
  bankAccounts = [];
  brandFullName: string;

  constructor(private ProfileBankingInfoV2, private $routeParams, private $scope, private $resource, private brand) {
    this.brandFullName = this.brand.getBrandFullName();
    ProfileBankingInfoV2.get().$promise.then(this.updateBankingInfo.bind(this));
  }

  updateBankingInfo(bankingInfo) {
    this.bankingInfo = bankingInfo;
  }

  changeBank(investmentAccount) {
    const workflowUrl = `/app/bank-accounts/${investmentAccount.id}`;
    window.location.assign(workflowUrl);
  }

  async cancelRequest(pendingRequestid, e) {
    e.target.setAttribute('disabled', '');
    const cancelResource = this.ProfileBankingInfoV2.cancelRequest;
    const getResource = this.ProfileBankingInfoV2.get;

    cancelResource({ investmentAccountBankRequestId: pendingRequestid })
     .$promise
     .then((function() {
       getResource()
         .$promise
         .then(this.updateBankingInfo.bind(this))
         .finally(() => e.target.removeAttribute('disabled'));
     }).bind(this))
     .catch(() => e.target.removeAttribute('disabled'));
  }
}

angular.module('wbComponents')
  .controller("ProfileBankingInfoV2Controller", ProfileBankingInfoV2Controller)
  .directive('profileBankingInfoV2', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileBankingInfoV2Controller",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
